import { XScale } from 'components/Charting/ChartBuilder';
import { SVGGSelection } from 'components/Charting/types';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { AppThemeType } from 'store/types';

const update = ({
  appTheme,
  chartG,
  innerHeight,
  xScale,
}: {
  appTheme: AppThemeType;
  chartG: SVGGSelection;
  innerHeight: number;
  xScale: XScale;
}) => {
  const currentTime = new Date();
  const xPos = xScale(currentTime);

  const currentTimeLine = chartG.select('.current-time');

  const blueBase = cxTheme.colors.blue.base;
  const darkModeBlue = cxTheme.colors.blue.lighten80;
  const stroke = appTheme === 'light' ? blueBase : darkModeBlue;

  const isInitialising = !currentTimeLine.size();

  if (isInitialising) {
    const greenBase = cxTheme.colors.green.base;

    const currentTimeGroup = chartG.append('g').classed('current-time', true);

    currentTimeGroup
      .append('line')
      .attr('x1', 0)
      .attr('x2', 0)
      .attr('y1', 8)
      .attr('y2', innerHeight)
      .attr('stroke', stroke)
      .attr('stroke-width', 2);

    currentTimeGroup
      .append('circle')
      .attr('r', 7)
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('fill', 'none')
      .attr('stroke', stroke)
      .attr('stroke-width', 2);

    currentTimeGroup
      .append('circle')
      .attr('r', 3)
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('fill', greenBase);

    currentTimeGroup.attr('transform', `translate(${xPos})`);

    return;
  }

  currentTimeLine
    .attr('transform', `translate(${xPos})`)
    .select('line')
    .attr('y2', innerHeight)
    .attr('stroke', stroke);

  currentTimeLine.select('circle').attr('stroke', stroke);
};

export const currentTimeLineBuilder = () => {
  return { update };
};
